/**
 * De stappen die een opname doorloopt voordat de buddy aan zet is.
 *
 * Hier en niet in de Worker of de client, om dezelfde reden als
 * `MEETING_STATUSSEN`: de server schrijft de fase weg en het scherm tekent hem,
 * en die twee stonden met de hand overgeschreven aan weerszijden. Een fase
 * erbij was dan twee losse bewerkingen die de compiler niet aan elkaar
 * verbindt.
 */
/** Wat de server meldt. Zie `voortgang.service.ts`. */
export const SERVERFASEN = ['omzetten', 'uitschrijven', 'samenvatten'];
/**
 * Wat de buddy te zien krijgt. `uploaden` zit er aan de voorkant bij: dat
 * gebeurt in de browser en komt daarvandaan, maar het is voor hem wel de eerste
 * stap van hetzelfde proces.
 */
export const VERWERKINGSFASEN = ['uploaden', ...SERVERFASEN];
export const FASE_LABEL = {
    uploaden: 'Uploaden',
    omzetten: 'Omzetten',
    uitschrijven: 'Uitschrijven',
    samenvatten: 'Samenvatten',
};
/** Waar een stap in de balk staat ten opzichte van de fase die nu loopt. */
export function faseStand(actief, stap) {
    const hier = VERWERKINGSFASEN.indexOf(actief);
    const daar = VERWERKINGSFASEN.indexOf(stap);
    if (daar < hier)
        return 'klaar';
    if (daar > hier)
        return 'open';
    return 'bezig';
}
/**
 * Wanneer er "Dit kan even duren" bij komt te staan.
 *
 * De teller laat zien dát er iets gebeurt; deze zin bevestigt dat lang hier
 * normaal is. Zonder die bevestiging telt de buddy seconden weg zonder te weten
 * of dat erg is. Per stap en niet over het geheel: het uitschrijven haalt deze
 * drempel bijna altijd, het omzetten alleen bij een lange opname.
 */
export const LANGZAAM_NA_SECONDEN = 60;
export const DUURT_LANG_TEKST = 'Dit kan even duren.';
export const duurtLang = (secondenInDezeStap) => secondenInDezeStap >= LANGZAAM_NA_SECONDEN;
